"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class NewsSubscribe extends React.Component {
    constructor() {
        super(...arguments);
        this.createMarkup = () => {
            return { __html: this.props.body };
        };
    }
    render() {
        return (React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup() }));
    }
}
exports.NewsSubscribe = NewsSubscribe;
exports.default = NewsSubscribe;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-news-subscribe/NewsSubscribe.tsx